export default "__VITE_ASSET__3561e9fb__"